export var customTexts = function customTexts(strictLocalize) {
  return {
    actionPaymentCompleted: strictLocalize({
      id: "I8qY2N",
      defaultMessage: [{
        "type": 0,
        "value": "Pagamento concluído"
      }]
    }),
    actionPaymentError: strictLocalize({
      id: "ZAyV+v",
      defaultMessage: [{
        "type": 0,
        "value": "Ocorreu um erro ao processar o cartão. Tente novamente ou utilize outro cartão."
      }]
    }),
    actionPostbackError: strictLocalize({
      id: "4nX2E/",
      defaultMessage: [{
        "type": 0,
        "value": "Ocorreu um erro ao processar a sua ação. Tente novamente."
      }]
    }),
    clickToRetry: strictLocalize({
      id: "VtFpKp",
      defaultMessage: [{
        "type": 0,
        "value": "Mensagem não entregue. Atualize o navegador para tentar novamente."
      }]
    }),
    clickToRetryForm: strictLocalize({
      id: "u15Uck",
      defaultMessage: [{
        "type": 0,
        "value": "Formulário não enviado. Clique em qualquer local do formulário para tentar novamente."
      }]
    }),
    connectNotificationText: strictLocalize({
      id: "FNME6m",
      defaultMessage: [{
        "type": 0,
        "value": "Sincronize a conversa e continue a enviar-nos mensagens na sua aplicação preferida."
      }]
    }),
    connectNotificationSingleText: strictLocalize({
      id: "SQ7ADB",
      defaultMessage: [{
        "type": 0,
        "value": "Receba uma notificação quando receber uma resposta."
      }]
    }),
    conversationListHeaderText: strictLocalize({
      id: "8mVcn4",
      defaultMessage: [{
        "type": 0,
        "value": "As minhas conversas"
      }]
    }),
    conversationListPreviewAnonymousText: strictLocalize({
      id: "d5Sp/y",
      defaultMessage: [{
        "type": 0,
        "value": "Alguém"
      }]
    }),
    conversationListPreviewCarouselText: strictLocalize({
      id: "BNBuTY",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " enviou uma mensagem"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewFileText: strictLocalize({
      id: "Um9Kpq",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " enviou um ficheiro"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewFormText: strictLocalize({
      id: "1fsFts",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " enviou um formulário"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewFormResponseText: strictLocalize({
      id: "OMXLSv",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " preencheu um formulário"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewImageText: strictLocalize({
      id: "8nkquk",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " enviou uma imagem"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewLocationRequestText: strictLocalize({
      id: "p/7Vs+",
      defaultMessage: [{
        "type": 1,
        "value": "userPersonName"
      }, {
        "type": 0,
        "value": " enviou um pedido de localização"
      }]
    }, {
      userPersonName: "{user}"
    }),
    conversationListPreviewUserText: strictLocalize({
      id: "5p2Qih",
      defaultMessage: [{
        "type": 0,
        "value": "Eu"
      }]
    }),
    conversationListRelativeTimeJustNow: strictLocalize({
      id: "72Tqww",
      defaultMessage: [{
        "type": 0,
        "value": "Agora mesmo"
      }]
    }),
    conversationListRelativeTimeMinute: strictLocalize({
      id: "IjmHdR",
      defaultMessage: [{
        "type": 0,
        "value": "Há 1 minuto"
      }]
    }),
    conversationListRelativeTimeMinutes: strictLocalize({
      id: "hBcPit",
      defaultMessage: [{
        "type": 0,
        "value": "Há "
      }, {
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " minutos"
      }]
    }, {
      valueTime: "{value}"
    }),
    conversationListRelativeTimeHour: strictLocalize({
      id: "GZ73D9",
      defaultMessage: [{
        "type": 0,
        "value": "Há 1 hora"
      }]
    }),
    conversationListRelativeTimeHours: strictLocalize({
      id: "D1AceC",
      defaultMessage: [{
        "type": 0,
        "value": "Há "
      }, {
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " horas"
      }]
    }, {
      valueTime: "{value}"
    }),
    conversationListRelativeTimeYesterday: strictLocalize({
      id: "9Cwjfp",
      defaultMessage: [{
        "type": 0,
        "value": "Ontem"
      }]
    }),
    couldNotConnect: strictLocalize({
      id: "UjUBuG",
      defaultMessage: [{
        "type": 0,
        "value": "Offline. Não receberá mensagens."
      }]
    }),
    couldNotConnectRetry: strictLocalize({
      id: "kXGiZU",
      defaultMessage: [{
        "type": 0,
        "value": "A restabelecer a ligação..."
      }]
    }),
    couldNotConnectRetrySuccess: strictLocalize({
      id: "WxKYO6",
      defaultMessage: [{
        "type": 0,
        "value": "Está novamente online."
      }]
    }),
    couldNotLoadConversations: strictLocalize({
      id: "NT287R",
      defaultMessage: [{
        "type": 0,
        "value": "Não foi possível carregar as conversas."
      }]
    }),
    emailChangeAddress: strictLocalize({
      id: "lMdZaG",
      defaultMessage: [{
        "type": 0,
        "value": "Alterar o meu e-mail"
      }]
    }),
    emailDescription: strictLocalize({
      id: "FtDtu+",
      defaultMessage: [{
        "type": 0,
        "value": "Para receber uma notificação por e-mail quando receber uma resposta, introduza o seu endereço de e-mail."
      }]
    }),
    emailFieldLabel: strictLocalize({
      id: "3bcv4v",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    emailFieldPlaceholder: strictLocalize({
      id: "2L9ili",
      defaultMessage: [{
        "type": 0,
        "value": "O seu endereço de e-mail"
      }]
    }),
    emailFormButton: strictLocalize({
      id: "OCxMgt",
      defaultMessage: [{
        "type": 0,
        "value": "Enviar"
      }]
    }),
    emailLinkingErrorMessage: strictLocalize({
      id: "pJuL3D",
      defaultMessage: [{
        "type": 0,
        "value": "Envie um endereço de e-mail válido."
      }]
    }),
    fetchHistory: strictLocalize({
      id: "n288kk",
      defaultMessage: [{
        "type": 0,
        "value": "Carregar mais"
      }]
    }),
    fetchingHistory: strictLocalize({
      id: "p0LVGs",
      defaultMessage: [{
        "type": 0,
        "value": "A recuperar o histórico..."
      }]
    }),
    fileTooLargeError: strictLocalize({
      id: "Yl3C6g",
      defaultMessage: [{
        "type": 0,
        "value": "Tamanho máximo do ficheiro excedido ("
      }, {
        "type": 1,
        "value": "sizeNumber"
      }, {
        "type": 0,
        "value": ")"
      }]
    }, {
      sizeNumber: "{size}"
    }),
    fileTypeError: strictLocalize({
      id: "GpVgdA",
      defaultMessage: [{
        "type": 0,
        "value": "Tipo de ficheiro não suportado."
      }]
    }),
    formErrorEntryRequired: strictLocalize({
      id: "U6eN9Z",
      defaultMessage: [{
        "type": 0,
        "value": "Este campo é obrigatório"
      }]
    }),
    formErrorInvalidEmail: strictLocalize({
      id: "CfLksk",
      defaultMessage: [{
        "type": 0,
        "value": "O e-mail é inválido"
      }]
    }),
    formErrorNoLongerThan: strictLocalize({
      id: "gZ/mqf",
      defaultMessage: [{
        "type": 0,
        "value": "Não deve conter mais do que ("
      }, {
        "type": 1,
        "value": "charactersNumber"
      }, {
        "type": 0,
        "value": ") caracteres"
      }]
    }, {
      charactersNumber: "{characters}"
    }),
    formErrorNoShorterThan: strictLocalize({
      id: "6UhNRq",
      defaultMessage: [{
        "type": 0,
        "value": "Deve conter pelo menos ("
      }, {
        "type": 1,
        "value": "charactersNumber"
      }, {
        "type": 0,
        "value": ") caracteres"
      }]
    }, {
      charactersNumber: "{characters}"
    }),
    formErrorUnknown: strictLocalize({
      id: "uHmA0t",
      defaultMessage: [{
        "type": 0,
        "value": "Algo não está bem"
      }]
    }),
    formFieldSelectPlaceholderFallback: strictLocalize({
      id: "IqApqR",
      defaultMessage: [{
        "type": 0,
        "value": "Escolha um..."
      }]
    }),
    frontendEmailChannelDescription: strictLocalize({
      id: "UrftLW",
      defaultMessage: [{
        "type": 0,
        "value": "Para falar connosco por e-mail, envie uma mensagem para o nosso endereço de e-mail e responderemos em breve:"
      }]
    }),
    headerText: strictLocalize({
      id: "LzUo5v",
      defaultMessage: [{
        "type": 0,
        "value": "Como podemos ajudar?"
      }]
    }),
    imageClickToReload: strictLocalize({
      id: "MYu9Dn",
      defaultMessage: [{
        "type": 0,
        "value": "Clique para voltar a carregar a imagem."
      }]
    }),
    imageClickToView: strictLocalize({
      id: "iDcbK1",
      defaultMessage: [{
        "type": 0,
        "value": "Clique para ver "
      }, {
        "type": 1,
        "value": "sizeNumber"
      }, {
        "type": 0,
        "value": " imagem."
      }]
    }, {
      sizeNumber: "{size}"
    }),
    imagePreviewNotAvailable: strictLocalize({
      id: "7xJ0Oe",
      defaultMessage: [{
        "type": 0,
        "value": "Pré-visualização indisponível."
      }]
    }),
    inputPlaceholder: strictLocalize({
      id: "Qz0IJv",
      defaultMessage: [{
        "type": 0,
        "value": "Escreva uma mensagem..."
      }]
    }),
    inputPlaceholderBlocked: strictLocalize({
      id: "lKCy+g",
      defaultMessage: [{
        "type": 0,
        "value": "Preencha o formulário acima..."
      }]
    }),
    introAppText: strictLocalize({
      id: "WwisEh",
      defaultMessage: [{
        "type": 0,
        "value": "Envie-nos uma mensagem abaixo ou na sua aplicação preferida."
      }]
    }),
    lineChannelDescription: strictLocalize({
      id: "82iecS",
      defaultMessage: [{
        "type": 0,
        "value": "Para falar connosco na LINE, leia este código QR com a aplicação LINE e envie-nos uma mensagem."
      }]
    }),
    linkError: strictLocalize({
      id: "hlZfbl",
      defaultMessage: [{
        "type": 0,
        "value": "Ocorreu um erro ao tentar gerar um link para este canal. Tente novamente."
      }]
    }),
    linkChannelPageHeader: strictLocalize({
      id: "jSbwQA",
      defaultMessage: [{
        "type": 0,
        "value": "Sincronize a sua conversa"
      }]
    }),
    locationNotSupported: strictLocalize({
      id: "0cajDz",
      defaultMessage: [{
        "type": 0,
        "value": "O seu navegador não suporta serviços de localização ou foram desativados. Escreva a sua localização."
      }]
    }),
    locationSecurityRestriction: strictLocalize({
      id: "Q20rDu",
      defaultMessage: [{
        "type": 0,
        "value": "Este site não pode aceder à sua localização. Escreva a sua localização."
      }]
    }),
    locationSendingFailed: strictLocalize({
      id: "XWNAd3",
      defaultMessage: [{
        "type": 0,
        "value": "Não foi possível enviar a localização"
      }]
    }),
    locationServicesDenied: strictLocalize({
      id: "EavZzB",
      defaultMessage: [{
        "type": 0,
        "value": "Este site não pode aceder à sua localização. Permita o acesso nas definições ou escreva a sua localização."
      }]
    }),
    messageIndicatorTitlePlural: strictLocalize({
      id: "0+VvFB",
      defaultMessage: [{
        "type": 1,
        "value": "countNumber"
      }, {
        "type": 0,
        "value": " novas mensagens"
      }]
    }, {
      countNumber: "{count}"
    }),
    messageIndicatorTitleSingular: strictLocalize({
      id: "CSCZoW",
      defaultMessage: [{
        "type": 1,
        "value": "countNumber"
      }, {
        "type": 0,
        "value": " nova mensagem"
      }]
    }, {
      countNumber: "{count}"
    }),
    messageRelativeTimeDay: strictLocalize({
      id: "xo/4Yu",
      defaultMessage: [{
        "type": 0,
        "value": "Há "
      }, {
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " dias"
      }]
    }, {
      valueTime: "{value}"
    }),
    messageRelativeTimeHour: strictLocalize({
      id: "bdg3Pr",
      defaultMessage: [{
        "type": 0,
        "value": "Há "
      }, {
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " horas"
      }]
    }, {
      valueTime: "{value}"
    }),
    messageRelativeTimeJustNow: strictLocalize({
      id: "72Tqww",
      defaultMessage: [{
        "type": 0,
        "value": "Agora mesmo"
      }]
    }),
    messageRelativeTimeMinute: strictLocalize({
      id: "SyJ9Zm",
      defaultMessage: [{
        "type": 0,
        "value": "Há "
      }, {
        "type": 1,
        "value": "valueTime"
      }, {
        "type": 0,
        "value": " minutos"
      }]
    }, {
      valueTime: "{value}"
    }),
    messageDelivered: strictLocalize({
      id: "I9y4Q1",
      defaultMessage: [{
        "type": 0,
        "value": "Entregue"
      }]
    }),
    messageSeen: strictLocalize({
      id: "2552ol",
      defaultMessage: [{
        "type": 0,
        "value": "Vista"
      }]
    }),
    messageSending: strictLocalize({
      id: "CzlJFq",
      defaultMessage: [{
        "type": 0,
        "value": "A enviar..."
      }]
    }),
    messengerChannelDescription: strictLocalize({
      id: "EBuhyl",
      defaultMessage: [{
        "type": 0,
        "value": "Associe a sua conta do Facebook Messenger para receber uma notificação quando receber uma resposta e continuar a conversa no Facebook Messenger."
      }]
    }),
    newConversationButtonText: strictLocalize({
      id: "79XsJP",
      defaultMessage: [{
        "type": 0,
        "value": "Nova conversa"
      }]
    }),
    notificationSettingsChannelsDescription: strictLocalize({
      id: "nmmSL2",
      defaultMessage: [{
        "type": 0,
        "value": "Ligue-se à sua aplicação de mensagens preferida para sincronizar esta conversa e continuá-la como pretender."
      }]
    }),
    notificationSettingsChannelsTitle: strictLocalize({
      id: "WuUmeV",
      defaultMessage: [{
        "type": 0,
        "value": "Outros canais"
      }]
    }),
    notificationSettingsConnected: strictLocalize({
      id: "h3RKIm",
      defaultMessage: [{
        "type": 0,
        "value": "Ligado(a)"
      }]
    }),
    notificationSettingsConnectedAs: strictLocalize({
      id: "uepWZ4",
      defaultMessage: [{
        "type": 0,
        "value": "Sessão iniciada como "
      }, {
        "type": 1,
        "value": "userPersonName"
      }]
    }, {
      userPersonName: "{username}"
    }),
    prechatCaptureGreetingText: strictLocalize({
      id: "JUJtTk",
      defaultMessage: [{
        "type": 0,
        "value": "Olá. Para começar, queremos saber um pouco mais sobre si:"
      }]
    }),
    prechatCaptureNameLabel: strictLocalize({
      id: "uLbNUt",
      defaultMessage: [{
        "type": 0,
        "value": "O seu nome"
      }]
    }),
    prechatCaptureNamePlaceholder: strictLocalize({
      id: "RwY05X",
      defaultMessage: [{
        "type": 0,
        "value": "Escreva o seu nome..."
      }]
    }),
    prechatCaptureEmailLabel: strictLocalize({
      id: "kJy+AB",
      defaultMessage: [{
        "type": 0,
        "value": "E-mail"
      }]
    }),
    prechatCaptureEmailPlaceholder: strictLocalize({
      id: "bHoo9p",
      defaultMessage: [{
        "type": 0,
        "value": "nome@empresa.com"
      }]
    }),
    prechatCaptureConfirmationText: strictLocalize({
      id: "MxlmAH",
      defaultMessage: [{
        "type": 0,
        "value": "Os nossos agradecimentos. Em que podemos ajudar?"
      }]
    }),
    prechatCaptureMailgunLinkingConfirmation: strictLocalize({
      id: "qhC82s",
      defaultMessage: [{
        "type": 0,
        "value": "Vai receber uma notificação aqui e por e-mail para o endereço "
      }, {
        "type": 1,
        "value": "emailEmailAddress"
      }, {
        "type": 0,
        "value": " assim que respondermos."
      }]
    }, {
      emailEmailAddress: "{email}"
    }),
    sendButtonText: strictLocalize({
      id: "xLWTdR",
      defaultMessage: [{
        "type": 0,
        "value": "Enviar"
      }]
    }),
    settingsHeaderText: strictLocalize({
      id: "0QV6z2",
      defaultMessage: [{
        "type": 0,
        "value": "Definições"
      }]
    }),
    shareLocation: strictLocalize({
      id: "rvirM2",
      defaultMessage: [{
        "type": 0,
        "value": "Local"
      }]
    }),
    smsBadRequestError: strictLocalize({
      id: "d5wiZz",
      defaultMessage: [{
        "type": 0,
        "value": "Não foi possível comunicar com este número. Tente novamente ou utilize outro número."
      }]
    }),
    smsCancel: strictLocalize({
      id: "gHLemI",
      defaultMessage: [{
        "type": 0,
        "value": "Cancelar"
      }]
    }),
    smsChangeNumber: strictLocalize({
      id: "T9LQOH",
      defaultMessage: [{
        "type": 0,
        "value": "Alterar o meu número"
      }]
    }),
    smsChannelDescription: strictLocalize({
      id: "E9/0ru",
      defaultMessage: [{
        "type": 0,
        "value": "Associe o seu número de SMS para receber uma notificação quando receber uma resposta e continuar a conversa por SMS."
      }]
    }),
    smsChannelPendingDescription: strictLocalize({
      id: "spQ3hG",
      defaultMessage: [{
        "type": 0,
        "value": "Consulte as mensagens do número "
      }, {
        "type": 1,
        "value": "phoneNumber"
      }, {
        "type": 0,
        "value": " para confirmar o número de telefone."
      }]
    }, {
      phoneNumber: "{number}"
    }),
    smsContinue: strictLocalize({
      id: "xLWTdR",
      defaultMessage: [{
        "type": 0,
        "value": "Enviar"
      }]
    }),
    smsInvalidNumberError: strictLocalize({
      id: "QaDAmJ",
      defaultMessage: [{
        "type": 0,
        "value": "Envie um número de telefone válido."
      }]
    }),
    smsLinkCancelled: strictLocalize({
      id: "q4dN8U",
      defaultMessage: [{
        "type": 0,
        "value": "A chamada para o "
      }, {
        "type": 1,
        "value": "appUserNumber"
      }, {
        "type": 0,
        "value": " foi cancelada."
      }]
    }, {
      appUserNumber: "{appUserNumber}"
    }),
    smsLinkPending: strictLocalize({
      id: "I1RY7U",
      defaultMessage: [{
        "type": 0,
        "value": "Pendente"
      }]
    }),
    smsPingChannelError: strictLocalize({
      id: "UBAoB1",
      defaultMessage: [{
        "type": 0,
        "value": "Ocorreu um erro ao enviar uma mensagem para o seu número."
      }]
    }),
    smsSendText: strictLocalize({
      id: "x7rAeU",
      defaultMessage: [{
        "type": 0,
        "value": "Enviem-me uma mensagem"
      }]
    }),
    smsStartTexting: strictLocalize({
      id: "TGJUj4",
      defaultMessage: [{
        "type": 0,
        "value": "Enviar mensagens"
      }]
    }),
    smsTooManyRequestsError: strictLocalize({
      id: "jVSLkV",
      defaultMessage: [{
        "type": 0,
        "value": "Já foi solicitada uma chamada para esse número recentemente. Tente novamente dentro de "
      }, {
        "type": 1,
        "value": "minutesTime"
      }, {
        "type": 0,
        "value": " minutos."
      }]
    }, {
      minutesTime: "{minutes}"
    }),
    smsTooManyRequestsOneMinuteError: strictLocalize({
      id: "0XliGQ",
      defaultMessage: [{
        "type": 0,
        "value": "Uma ligação para esse número foi pedida recentemente. Tente novamente dentro de 1 minuto."
      }]
    }),
    smsUnhandledError: strictLocalize({
      id: "W1a+Iy",
      defaultMessage: [{
        "type": 0,
        "value": "Ocorreu um erro. Tente novamente."
      }]
    }),
    syncConversation: strictLocalize({
      id: "B2qj3w",
      defaultMessage: [{
        "type": 0,
        "value": "Sincronizar conversa"
      }]
    }),
    tapToRetry: strictLocalize({
      id: "P7ZSoc",
      defaultMessage: [{
        "type": 0,
        "value": "Mensagem não entregue. Toque para tentar novamente."
      }]
    }),
    tapToRetryForm: strictLocalize({
      id: "QqMyCB",
      defaultMessage: [{
        "type": 0,
        "value": "Formulário não enviado. Toque em qualquer local do formulário para tentar novamente."
      }]
    }),
    telegramChannelDescription: strictLocalize({
      id: "Rtuws+",
      defaultMessage: [{
        "type": 0,
        "value": "Associe a sua conta do Telegram para receber uma notificação quando receber uma resposta e continuar a conversa no Telegram"
      }]
    }),
    unsupportedMessageType: strictLocalize({
      id: "E9qCDM",
      defaultMessage: [{
        "type": 0,
        "value": "Tipo de mensagem não suportado."
      }]
    }),
    unsupportedActionType: strictLocalize({
      id: "mMB611",
      defaultMessage: [{
        "type": 0,
        "value": "Tipo de ação não suportado."
      }]
    }),
    uploadDocument: strictLocalize({
      id: "hdlOID",
      defaultMessage: [{
        "type": 0,
        "value": "Ficheiro"
      }]
    }),
    uploadInvalidError: strictLocalize({
      id: "gn05y6",
      defaultMessage: [{
        "type": 0,
        "value": "Ficheiro inválido"
      }]
    }),
    uploadPhoto: strictLocalize({
      id: "OAzZGu",
      defaultMessage: [{
        "type": 0,
        "value": "Imagem"
      }]
    }),
    uploadVirusError: strictLocalize({
      id: "x5EOZK",
      defaultMessage: [{
        "type": 0,
        "value": "Foi detetado um vírus no seu ficheiro e o mesmo foi rejeitado"
      }]
    }),
    viberChannelDescription: strictLocalize({
      id: "Z3K0oO",
      defaultMessage: [{
        "type": 0,
        "value": "Associe a sua conta do Viber para receber uma notificação quando receber uma resposta e continuar a conversa no Viber. Para começar, utilize a aplicação Viber para ler o código QR."
      }]
    }),
    viberChannelDescriptionMobile: strictLocalize({
      id: "xuYgMg",
      defaultMessage: [{
        "type": 0,
        "value": "Associe a sua conta do Viber para receber uma notificação quando receber uma resposta e continuar a conversa no Viber. Para começar, instale a aplicação Viber e toque em Associar."
      }]
    }),
    viberQRCodeError: strictLocalize({
      id: "AYSCMJ",
      defaultMessage: [{
        "type": 0,
        "value": "Ocorreu um erro ao obter o seu código QR do Viber. Tente novamente."
      }]
    }),
    wechatChannelDescription: strictLocalize({
      id: "qIPntD",
      defaultMessage: [{
        "type": 0,
        "value": "Associe a sua conta do WeChat para receber uma notificação quando receber uma resposta e continuar a conversa no WeChat. Para começar, utilize a aplicação WeChat para ler este código QR."
      }]
    }),
    wechatChannelDescriptionMobile: strictLocalize({
      id: "4p4TBs",
      defaultMessage: [{
        "type": 0,
        "value": "Associe a sua conta do WeChat para receber uma notificação quando receber uma resposta e continuar a conversa no WeChat. Para começar, guarde esta imagem de código QR e carregue-a no leitor de códigos QR."
      }]
    }),
    wechatQRCodeError: strictLocalize({
      id: "TdTat4",
      defaultMessage: [{
        "type": 0,
        "value": "Ocorreu um erro ao obter o seu código QR do WeChat. Tente novamente."
      }]
    }),
    whatsappChannelDescriptionDesktop: strictLocalize({
      id: "tlAllf",
      defaultMessage: [{
        "type": 0,
        "value": "Leia o código QR ou clique no link abaixo para sincronizar a sua conta com o WhatsApp. Em seguida, envie a mensagem pré-preenchida para validar o pedido de sincronização. (O seu código: "
      }, {
        "type": 1,
        "value": "codeNumber"
      }, {
        "type": 0,
        "value": ")"
      }]
    }, {
      codeNumber: "{code}"
    }),
    whatsappChannelDescriptionMobile: strictLocalize({
      id: "/YEwfr",
      defaultMessage: [{
        "type": 0,
        "value": "Clique no link abaixo para sincronizar a sua conta com o WhatsApp. Em seguida, envie a mensagem pré-preenchida para validar o pedido de sincronização. (O seu código: "
      }, {
        "type": 1,
        "value": "codeNumber"
      }, {
        "type": 0,
        "value": ")"
      }]
    }, {
      codeNumber: "{code}"
    }),
    whatsappLinkingError: strictLocalize({
      id: "49auTS",
      defaultMessage: [{
        "type": 0,
        "value": "Ocorreu um erro ao obter as informações de associação ao WhatsApp. Tente novamente."
      }]
    })
  };
};